import { atom } from "jotai";

// アイコン強調表示の状態を管理するAtom
export const isSavedHighlightedAtom = atom(false);
export const isVisitedHighlightedAtom = atom(false);

// 強調表示をトリガーするためのWrite-only Atom
export const highlightSavedAtom = atom(null, (_get, set) => {
  set(isSavedHighlightedAtom, true);
  setTimeout(() => {
    set(isSavedHighlightedAtom, false);
  }, 1000);
});

export const highlightVisitedAtom = atom(null, (_get, set) => {
  set(isVisitedHighlightedAtom, true);
  setTimeout(() => {
    set(isVisitedHighlightedAtom, false);
  }, 1000);
});
